import { useTranslate } from 'hooks/use-translation';
import { DemandRoleEvent } from '../../event-types';
import { getTotalAllocatedMinutes } from '../../utils/common';

export const demandRoleTemplate = ({
  id,
  capacity,
  usersAllocatedMinutes,
  teamsAllocatedMinutes,
}: Pick<
  DemandRoleEvent,
  | 'id'
  | 'roleId'
  | 'capacity'
  | 'usersAllocatedMinutes'
  | 'teamsAllocatedMinutes'
>): string => {
  const totalAllocatedMinutes =
    getTotalAllocatedMinutes(usersAllocatedMinutes) +
    getTotalAllocatedMinutes(teamsAllocatedMinutes);

  return `<div class="content" data-event-id=${id}>${
    capacity === 0
      ? 'NA'
      : `${Math.round((totalAllocatedMinutes / capacity) * 100)}%`
  }</div`;
};

export const demandRoleTooltip = (
  {
    capacity,
    roleName,
    usersAllocatedMinutes,
    teamsAllocatedMinutes,
  }: Pick<
    DemandRoleEvent,
    | 'id'
    | 'roleId'
    | 'capacity'
    | 'usersAllocatedMinutes'
    | 'teamsAllocatedMinutes'
  > & { roleName: string },
  translate: ReturnType<typeof useTranslate>,
): string => {
  const totalAllocatedMinutes =
    getTotalAllocatedMinutes(usersAllocatedMinutes) +
    getTotalAllocatedMinutes(teamsAllocatedMinutes);
  const allocatedPercentage = Math.round(
    (totalAllocatedMinutes / capacity) * 100,
  );

  if (capacity === 0) {
    return `${translate('resource_management.demand_role_summary.tooltip.na', {
      roleName,
      strong: (chunks) => `<strong>${chunks}</strong>`,
    })}`;
  }

  return `${translate('resource_management.demand_role_summary.tooltip', {
    roleName,
    percentage: `${allocatedPercentage}%`,
    strong: (chunks) => `<strong>${chunks}</strong>`,
    demand: (chunks) =>
      `<strong style="color:${
        allocatedPercentage < 100 ? 'var(--green-20)' : 'var(--red-30)'
      }">${chunks}</strong>`,
  })}
  <br/><br/>${translate('resource_management.demand_role_summary.formula')}`;
};
